import { FeatureFlag, Product } from "@/__generated__/graphql";
import isManagedAgentsWorkspace from "@/utils/isManagedAgentsWorkspace";

type WorkspaceForProduct = {
  products?: Product[] | null;
  featureFlags?: FeatureFlag[];
};

// Resolves which product surface a workspace is currently in, so the chrome
// (logo, subtitle) matches the content. Route-based products win first, then
// Managed Agents workspaces, then the workspace's own product list.
export default function resolveWorkspaceProduct(
  asPath: string,
  workspace: WorkspaceForProduct | null | undefined
): Product {
  if (asPath.includes("instantdatasets")) {
    return Product.StandaloneDatasets;
  }
  if (asPath.includes("/ai/")) {
    return Product.ReleaseAi;
  }
  if (isManagedAgentsWorkspace(workspace)) {
    return Product.ManagedAgents;
  }
  if (workspace?.products) {
    return workspace.products.includes(Product.Release) ? Product.Release : Product.StandaloneDatasets;
  }
  return Product.Release;
}
